// src/components/search/InstitutionalDocumentCard.tsx

import React from 'react';
import { Card, CardContent, Typography, Chip, Stack, Box, Button } from '@mui/material';
import { Description, Download } from '@mui/icons-material';
import { InstitutionalDocument } from '@/types/search.types';

interface InstitutionalDocumentCardProps {
  document: InstitutionalDocument;
  downloading: string | null;
  onDownload: (storagePath: string, fileName: string) => void;
}

export const InstitutionalDocumentCard: React.FC<InstitutionalDocumentCardProps> = ({
  document,
  downloading,
  onDownload,
}) => (
  <Card sx={{ mb: 2, '&:hover': { boxShadow: 3 } }}>
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Description sx={{ color: 'primary.dark', mt: 0.5 }} />
        <Box flex={1}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            {document.title}
          </Typography>
          {document.description && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {document.description}
            </Typography>
          )}
          <Stack direction="row" spacing={1} alignItems="center">
            {document.category && (
              <Chip label={document.category} size="small" variant="outlined" sx={{color:"primary.200"}}/>
            )}
            <Button
              size="small"
              startIcon={downloading === document.url ? null : <Download />}
              onClick={() => onDownload(document.url, document.title)}
              disabled={downloading === document.url}
              variant="outlined"
            >
              {downloading === document.url ? 'Descargando...' : 'Descargar'}
            </Button>
          </Stack>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);
